/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PickemRouteImport } from './routes/pickem'
import { Route as LoginRouteImport } from './routes/login'
import { Route as CounterRouteImport } from './routes/counter'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PickemIndexRouteImport } from './routes/pickem.index'
import { Route as PickemEventIdRouteImport } from './routes/pickem.$eventId'
import { Route as AuthenticatedRewardsRouteImport } from './routes/_authenticated/rewards'
import { Route as AuthenticatedAppRouteImport } from './routes/_authenticated/app'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PickemRoute = PickemRouteImport.update({
  id: '/pickem',
  path: '/pickem',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const CounterRoute = CounterRouteImport.update({
  id: '/counter',
  path: '/counter',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PickemIndexRoute = PickemIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PickemRoute,
} as any)
const PickemEventIdRoute = PickemEventIdRouteImport.update({
  id: '/$eventId',
  path: '/$eventId',
  getParentRoute: () => PickemRoute,
} as any)
const AuthenticatedRewardsRoute = AuthenticatedRewardsRouteImport.update({
  id: '/rewards',
  path: '/rewards',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAppRoute = AuthenticatedAppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => AuthenticatedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/counter': typeof CounterRoute
  '/login': typeof LoginRoute
  '/pickem': typeof PickemRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/app': typeof AuthenticatedAppRoute
  '/rewards': typeof AuthenticatedRewardsRoute
  '/pickem/$eventId': typeof PickemEventIdRoute
  '/pickem/': typeof PickemIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/counter': typeof CounterRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/app': typeof AuthenticatedAppRoute
  '/rewards': typeof AuthenticatedRewardsRoute
  '/pickem/$eventId': typeof PickemEventIdRoute
  '/pickem': typeof PickemIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/counter': typeof CounterRoute
  '/login': typeof LoginRoute
  '/pickem': typeof PickemRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/_authenticated/app': typeof AuthenticatedAppRoute
  '/_authenticated/rewards': typeof AuthenticatedRewardsRoute
  '/pickem/$eventId': typeof PickemEventIdRoute
  '/pickem/': typeof PickemIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/counter'
    | '/login'
    | '/pickem'
    | '/privacy'
    | '/terms'
    | '/app'
    | '/rewards'
    | '/pickem/$eventId'
    | '/pickem/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/counter'
    | '/login'
    | '/privacy'
    | '/terms'
    | '/app'
    | '/rewards'
    | '/pickem/$eventId'
    | '/pickem'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/counter'
    | '/login'
    | '/pickem'
    | '/privacy'
    | '/terms'
    | '/_authenticated/app'
    | '/_authenticated/rewards'
    | '/pickem/$eventId'
    | '/pickem/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  CounterRoute: typeof CounterRoute
  LoginRoute: typeof LoginRoute
  PickemRoute: typeof PickemRouteWithChildren
  PrivacyRoute: typeof PrivacyRoute
  TermsRoute: typeof TermsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pickem': {
      id: '/pickem'
      path: '/pickem'
      fullPath: '/pickem'
      preLoaderRoute: typeof PickemRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/counter': {
      id: '/counter'
      path: '/counter'
      fullPath: '/counter'
      preLoaderRoute: typeof CounterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pickem/': {
      id: '/pickem/'
      path: '/'
      fullPath: '/pickem/'
      preLoaderRoute: typeof PickemIndexRouteImport
      parentRoute: typeof PickemRoute
    }
    '/pickem/$eventId': {
      id: '/pickem/$eventId'
      path: '/$eventId'
      fullPath: '/pickem/$eventId'
      preLoaderRoute: typeof PickemEventIdRouteImport
      parentRoute: typeof PickemRoute
    }
    '/_authenticated/rewards': {
      id: '/_authenticated/rewards'
      path: '/rewards'
      fullPath: '/rewards'
      preLoaderRoute: typeof AuthenticatedRewardsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app': {
      id: '/_authenticated/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AuthenticatedAppRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedAppRoute: typeof AuthenticatedAppRoute
  AuthenticatedRewardsRoute: typeof AuthenticatedRewardsRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAppRoute: AuthenticatedAppRoute,
  AuthenticatedRewardsRoute: AuthenticatedRewardsRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface PickemRouteChildren {
  PickemEventIdRoute: typeof PickemEventIdRoute
  PickemIndexRoute: typeof PickemIndexRoute
}

const PickemRouteChildren: PickemRouteChildren = {
  PickemEventIdRoute: PickemEventIdRoute,
  PickemIndexRoute: PickemIndexRoute,
}

const PickemRouteWithChildren =
  PickemRoute._addFileChildren(PickemRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  CounterRoute: CounterRoute,
  LoginRoute: LoginRoute,
  PickemRoute: PickemRouteWithChildren,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
